import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { IServiceChangeRequest } from '../../../../core/models/service-change-request.model';
import { EServiceChangeRequestReviewSection } from '../../../../core/models/service-change-request-review-issue.model';

@Component({
  selector: 'irembogov-review-workflow-json-entry',
  templateUrl: './review-workflow-json-entry.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class ReviewWorkflowJsonEntryComponent {
  @Input() changeRequest!: IServiceChangeRequest;
  @Input() changeRequestJsonWorkflow!: Record<string, unknown>;
  @Input() activeWorkflowData: Record<string, unknown> | null = null;
  @Input() showDiff = false;
  @Output() reviewWorkflowJsonCompleted: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  EServiceChangeRequestReviewSection = EServiceChangeRequestReviewSection;
}
